<template>
  <div class="stockApp">
    <div class="stock">
      <Header></Header>
      <main>
        <div class="mainBottom">
          <div style="width:100%;overflow:hidden;">
            <div class="underHeader">
                <img src="../../assets/img/info.png" style="width:12px;display:inline-block;" />
                当前位置：
                <a href="/#/index">平台首页 ></a>
                专题数据 > 政府采购
            </div>

            <iframe class="detailPage" id="iframe1" :src="'/tentapi/zfcg/getZfcgContent?contentKey=' + this.$route.query.id"></iframe>

            <!-- <div class="detailPage">
                <div class="title">特使三十岁</div>
                <div class="source" style="text-align:center;">
                    <span>发布日期：2020年06月14日 10:49</span>
                    <span>查看原文链接</span>
                </div>
                <div class="table">
                    <p class="titspan">一、项目编号：XXXXXXXXXXXXX</p>
                    <p class="titspan">二、项目名称：XXXXXXXXXXXXX</p>
                    <p class="titspan">三、中标（成交）信息：XXXXXXXXXXXXX</p>
                    <p class="titspan">1.中标结果：</p>
                    <table class="tables">
                        <tr>
                            <td class="column">序号</td>
                            <td class="column">中标（成交）金额（元）</td>
                            <td class="column">中标供应商名称</td>
                            <td class="column">中标供应商地址</td>
                        </tr>
                        <tr>
                            <td>序号</td>
                            <td>中标（成交）金额（元）</td>
                            <td>中标供应商名称</td>
                            <td>中标供应商地址</td>
                        </tr>
                    </table>
                    <p class="titspan">2.废标结果：</p>
                    <table class="tables">
                        <tr>
                            <td class="column" width="15%">序号</td>
                            <td class="column" width="35%">标项名称</td>
                            <td class="column" width="35%">废标理由</td>
                            <td class="column" width="35%">其他事项</td>
                        </tr>
                        <tr v-for="(v,i) in data" :key="i">
                            <td width="15%">{{i+1}}</td>
                            <td width="35%">{{v.caselitigantStatus}}</td>
                            <td width="35%">{{v.caselitigantName}}</td>
                            <td width="35%">test</td>
                        </tr>
                    </table>
                    <p class="titspan">四、主要标的信息</p>
                    <p class="titspan">1.货物类主要标的信息：</p>
                    <table class="tables">
                        <tr>
                            <td class="column">序号</td>
                            <td class="column">标项名称</td>
                            <td class="column">标的名称</td>
                            <td class="column">品牌</td>
                            <td class="column">数量</td>
                            <td class="column">单价</td>
                            <td class="column">规格型号</td>
                        </tr>
                        <tr v-for="(v,i) in data" :key="i">
                            <td width="15%">{{i+1}}</td>
                            <td width="35%">{{v.caselitigantStatus}}</td>
                            <td width="35%">{{v.caselitigantName}}</td>
                            <td width="35%">test</td>
                        </tr>
                    </table>
                    <p class="titspan">陆地边境地区是我国对外开放的前沿，是展示国家实力和形象的窗口，是确保国土安全的前沿阵地和生态安全的重要屏障，在全国改革发展稳定大局中具有重要战略地位。</p>
                </div>
            </div> -->
          </div>
        </div>
      </main>
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
import api from "@/../static/common/api/api.js";
import local from "@/assets/map/local.png";
import $ from 'jquery';
export default {
  props: {},
  components: {
    Header,
    Footer
  },
  data() {
    return {
      data: [],
      data2: [],
      data3: []
    };
  },
  computed: {},
  methods: {
    getWenshuDetail() {
        // console.log(this.$route.params,'params1')
        // this.$route.params.id  '00016083009647949fa4eff4783f712a'
        api.cpws_getWenshuDetail(this.$route.query.id).then(res => {
            // this.data = res.data;
            // $('.detailPage').html(res)
        });
    },
  },
  created() {},
  mounted() {
    this.getWenshuDetail();

    console.log(this.$route.query,'this.$route.params')
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/tableScrollbar.less";

.stockApp {
  background: url("../../assets/img/bg.png") no-repeat top;
}
.stock {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  .mainBottom {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
  // 面包屑样式
  .underHeader {
    display: inline-block;
    height: 55px;
    line-height: 55px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #dfecf7;
    overflow: hidden;
    a {
      color: #dfecf7;
    }
  }
  .detailPage {
    width: 1000px;
    height: 1200px;
    padding-top:80px;
    // background: rgba(5, 43, 79, 0.3);
    background: #fff;
    border: 1px solid #08396a;
    border-radius: 0px 0px 2px 2px;
    margin: 0 auto;
    padding: 0 22px;
    box-sizing: border-box;
    .xz {
      font-size: 14px;
      font-weight: 400;
      color: #3c98f5;
      margin-top: 37px;
      text-align: right;
      img {
        width: 14px;
        height: 14px;
        vertical-align: middle;
      }
    }
    .title {
      width: 80%;
      font-size: 24px;
      font-weight: 400;
      color: #dfecf7;
      line-height: 42px;
      margin: 0 auto;
      text-align: center;
      margin-top:50px;
    }
    .source {
      width: 80%;
      font-size: 12px;
      font-weight: 400;
      color: #dfecf7;
      line-height: 42px;
      margin: 0 auto;
      text-align: right;
    }
    .table {
      width: 80%;
      margin: 0 auto 70px;
      .titspan {
        margin-top: 40px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #dfecf7;
        line-height: 26px;
      }
      .tables {
        margin-top: 22px;
        width: 100%;
        td {
          height: 38px;

          border: 1px solid #08396a;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #dfecf7;
          text-indent: 6px;
        }
        .column {
          background: rgba(5, 43, 79, 0.8);
        }
      }
    }
  }
}
</style>
 


// WEBPACK FOOTER //
// src/view/tendering/detail.vue